var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9563_64687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.84087 4.04277L7.99996 1.88388L10.159 4.04316L9.01219 5.45135L8.14816 6.31328L8.14788 6.31356C8.10849 6.35291 8.0551 6.375 7.99944 6.375C7.94379 6.375 7.8904 6.35291 7.851 6.31356L7.85086 6.31342L6.9874 5.4515L5.84087 4.04277Z",
    stroke: "#4C5664",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.84087 12.0428L7.99996 9.88388L10.159 12.0432L9.01218 13.4513L8.14816 14.3133L8.14788 14.3136C8.10849 14.3529 8.0551 14.375 7.99944 14.375C7.94379 14.375 7.8904 14.3529 7.851 14.3136L7.85086 14.3134L6.98739 13.4515L5.84087 12.0428Z",
    stroke: "#4C5664",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.84087 8.04277L3.99996 5.88388L6.15903 8.04316L5.01218 9.45135L4.14816 10.3133L4.14788 10.3136C4.10849 10.3529 4.0551 10.375 3.99944 10.375C3.94379 10.375 3.8904 10.3529 3.851 10.3136L3.85086 10.3134L2.98739 9.4515L1.84087 8.04277Z",
    stroke: "#4C5664",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84087 8.04277L12 5.88388L14.159 8.04316L13.0122 9.45135L12.1482 10.3133L12.1479 10.3136C12.1085 10.3529 12.0551 10.375 11.9994 10.375C11.9438 10.375 11.8904 10.3529 11.851 10.3136L11.8509 10.3134L10.9874 9.4515L9.84087 8.04277Z",
    stroke: "#4C5664",
    strokeWidth: 1.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9563_64687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.ed7cdc904aa3327a18fdeaac0e2d4e10.svg";
export { ForwardRef as ReactComponent };